import videojs from 'video.js';

videojs.registerPlugin('showControlsBeforePlayback', class extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player);
		this.className = 'vjs-show-controls-before-playback';
		this.player.addClass(this.className);
	}

	setListeners() {
		this.player.one('play', () => {
			this.player.removeClass(this.className);
		});
	}
});
